import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './DateRangePicker.styles';

import { Icon } from '@/components/Icon';

dayjs.extend(utc);
dayjs.extend(timezone);

const { RangePicker } = DatePicker;

const DATE_FORMAT = 'DD MMM';
const POPUP_WIDTH = 288;

type Props = {
  value?: [dayjs.Dayjs, dayjs.Dayjs];
  onChange?: (value?: [Dayjs, Dayjs]) => void;
};

export const DateRangePicker: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const handleDateChange = (dates: [Dayjs, Dayjs] | null) => {
    if (!dates) return onChange?.();

    const [startDate, endDate] = dates;
    const adjustedStartDate = startDate ? startDate.hour(0).minute(0).second(0) : undefined;
    const adjustedEndDate = endDate ? endDate.hour(23).minute(59).second(59) : undefined;

    onChange?.(
      adjustedStartDate && adjustedEndDate ? [adjustedStartDate, adjustedEndDate] : undefined
    );
  };

  return (
    <Wrapper $hasValue={!!value && value.length > 0}>
      <RangePicker
        value={value}
        onChange={e => handleDateChange(e as [Dayjs, Dayjs])}
        separator={null}
        variant="borderless"
        suffixIcon={<Icon i="CaretDown" />}
        format={DATE_FORMAT}
        placeholder={[t('BEGINNING'), t('END')]}
        popupStyle={{ maxWidth: POPUP_WIDTH }}
      />
    </Wrapper>
  );
};
